import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import messages from "../../../../../../assets/locale/messages";
import { UIButton } from "../../../../../ui";
import { getZoneMaximumApprovedRequestsCount } from "../zoneStaffing";
import "../../../_EventDetailFields.scss";

const getZoneAbbr = (index = 0) => `Z${index + 1}`;

const ZoneHeader = ({ zone, index, isExpanded, onViewApplicants }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  const abbr = getZoneAbbr(index);
  const totalStaff = getZoneMaximumApprovedRequestsCount(zone);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1,
        gap: 2,
        minWidth: 0,
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}
      >
        <span className="event-detail-zone-index">{abbr}</span>

        <Box sx={{ minWidth: 0 }}>
          <span className="event-detail-accordion-title">
            {zone?.name ?? "—"}
          </span>
          {zone?.description && (
            <Typography
              sx={{
                fontSize: 10,
                fontWeight: 700,
                lineHeight: "15px",
                letterSpacing: "1px",
                color: "var(--color-foreground-muted)",
                display: "block",
              }}
            >
              {zone.description}
            </Typography>
          )}
        </Box>
      </Box>

      {!isExpanded ? (
        <span className="event-detail-staff-chip">
          {`${t.totalStaff}: ${totalStaff ? String(totalStaff).padStart(2, "0") : "0"}`}
        </span>
      ) : onViewApplicants ? (
        <UIButton
          variant="primary"
          appearance="outline"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onViewApplicants();
          }}
        >
          {t.viewApplicantsList}
        </UIButton>
      ) : null}
    </Box>
  );
};

ZoneHeader.propTypes = {
  zone: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onViewApplicants: PropTypes.func,
};

ZoneHeader.defaultProps = {
  onViewApplicants: undefined,
};

export default ZoneHeader;
